import { render, staticRenderFns } from "./layout-product-available.vue?vue&type=template&id=4520221c&scoped=true"
import script from "./layout-product-available.vue?vue&type=script&lang=js"
export * from "./layout-product-available.vue?vue&type=script&lang=js"
import style0 from "./layout-product-available.vue?vue&type=style&index=0&id=4520221c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520221c",
  null
  
)

export default component.exports